/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { Text } from '@myinterview/component-library';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SuccessImage from '../assets/images/success.svg';
import { IMessageType } from '../interfaces';
import { urlRegex } from '../utils/regex';
import { SupportedLinkDescription } from './SupportedLinkDescription';
import { VideoPlayer } from './VideoPlayer';

interface IPopupMessage {
  messageType: IMessageType;
  outroVideo?: string;
  thankYouMessage?: string;
  companyName?: string;
  candidateEmail: string;
}

export const PopupMessage:React.FC<IPopupMessage> = ({
  messageType,
  outroVideo,
  companyName,
  thankYouMessage,
  candidateEmail,
}) => {
  const { t } = useTranslation();
  const isSuccessIconShown = ['completed', 'applied'].includes(messageType);
  const isAutoPlay = document.documentElement.getAttribute('data-custom') === 'cluey-learning';
  const greetingKey = messageType === 'completed' ? 'completed.thanks' : 'hi';
  const popupMessage = messageType === 'completed' ? (thankYouMessage || t('completed.successMsg') || '')
    : messageType === 'applied' ? t('applied.description') : t('deadline.descriptionLine_1');

  const supportedLinkPopupMessage = useMemo(() => {
    const urls = popupMessage.match(urlRegex);
    const popupMessagesArray = popupMessage.split(urlRegex);
    return popupMessagesArray.map((text, idx) => (
      <SupportedLinkDescription
        key={text}
        text={text}
        link={urls?.[idx] ? urls[idx] : ''}
        query={`email=${candidateEmail}`}
      />
    ));
  }, [popupMessage]);

  return (
    <div className="message-container dynamic-direction">
      <div className="popup-wrapper">
        <div className="popup-message">
          { isSuccessIconShown && <img className="popup-message__icon" src={SuccessImage} alt="success" />}
          <Text className="popup-message__greeting" size="H3-Semibold">
            {t(greetingKey)}
          </Text>
          <Text className="popup-message__message" size="M-Regular">{supportedLinkPopupMessage}</Text>
          {messageType === 'deadline' && <Text className="popup-message__sub-message" size="M-Regular">{t('deadline.descriptionLine_2')}</Text>}
        </div>
        {messageType === 'deadline' && (
        <Text className="popup-message__info-message" size="S-Regular" color="neutral-60">
          {t('deadline.descriptionLine_3')}
          {companyName}
        </Text>
        )}
      </div>

      {messageType === 'completed' && outroVideo && (
      <div className="video-wrapper">
        <VideoPlayer videoUrl={outroVideo} autoPlay={isAutoPlay} />
      </div>
      )}
    </div>
  );
};
